var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdmin = function SvgAdmin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.628 18.284c.871-5.284-2.53-8.036-5.658-8.036H5.616c-2.9 0-6.117 2.752-5.247 8.036M7.794 9.103a4.41 4.41 0 1 0 0-8.819 4.41 4.41 0 0 0 0 8.819Z",
    fill: "currentColor"
  })));
};
export default SvgAdmin;